import { makeStyles } from '@mui/styles';

const styles = (theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column !important',
        alignItems:'center',
        backgroundColor: 'transparent',
    },

    popper: {
        zIndex: '2000 !important',
    },

    menuTail: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '8px',
        backgroundColor: '#FFFFFF',
    },

    menuTailImg: {
        zIndex: 2,
    },

    rootBody: {
        display: 'flex',  
        alignItems:'center',
        justifyContent: 'center',
        minWidth: '200px',
        height: '48px',
        backgroundColor: '#FFFFFF',
        boxShadow: '0px -1px 10px #00000020',
        overflow: 'hidden',
        borderRadius: '4px',
    },

    iconsParent: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: 'calc(100% - 16px)',
        height: 'calc(100% - 16px)',
        backgroundColor: '#FFFFFF',
        borderRadius: '8px',
    },

    icon: {
        borderRadius: '4px !important',
        width: '28px',
        height: '28px',
        backgroundColor: '#323232 !important',

        '& .MuiSvgIcon-root': {
            color: '#FFFFFF !important',
        },

        '&:hover': {
            backgroundColor: '#535353 !important',
        },
    },
    
    iconSpace: {
        marginRight: '8px',
    },

    iconX: {
        width: '20px !important',
        height: '20px !important',
    },
});

export default styles;
export const useStyles = makeStyles(styles);